<template>
  <div
    class="modal fade"
    :id="id"
    tabindex="-1"
    role="dialog"
    aria-labelledby="confirmModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-sm" role="document">
      <div class="modal-content">
        <div class="text-center py-2">
          <h5 class="font-weight-bold">Confirm</h5>
        </div>
        <div class="modal-body" style="overflow:hidden">
          <p id="confirmContent">
            <slot></slot>
          </p>
        </div>
        <div class="modal-footer">
          <input hidden id="itemId" />
          <input hidden id="listName" />
          <button
            type="button"
            class="btn btn-success"
            data-dismiss="modal"
            @click="accept()"
          >
            Accept
          </button>
          <button type="button" class="btn btn-primary" data-dismiss="modal">
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ConfirmModal",
  props: {
    id: { type: String, default: "ConfirmModal" }
  },
  methods: {
    accept() {
      this.$emit("accept");
    }, // Confirm Modal Accepted
    show() {
      $("#" + this.id).modal("show");
    }
  }
};
</script>
